import { useEffect } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import React from "react";

type ToastItem = {
    id: number;
    variant: "success" | "danger" | "warning" | "info";
    message: React.ReactNode;
    duration: number;
};

type ToastMessageProps = {
    toasts: ToastItem[];
    onClose: (id: number) => void;
    position?: "top-end" | "top-center" | "bottom-end" | "middle-center" | "bottom-center";
};

export default function ToastMessage({
    toasts,
    onClose,
    position = "middle-center",
}: ToastMessageProps) {
    useEffect(() => {
        const timers = toasts.map((t) =>
            setTimeout(() => onClose(t.id), t.duration)
        );
        return () => timers.forEach(clearTimeout);
    }, [toasts, onClose]);

    const posClass =
        position === "top-center"
            ? "top-0 start-50 translate-middle-x"
            : position === "bottom-center"
                ? "bottom-0 start-50 translate-middle-x"
                : position === "bottom-end"
                    ? "bottom-0 end-0"
                    : "top-0 end-0";

    return (
        <ToastContainer position={position} className="p-3" style={{ zIndex: 1 }}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    bg={toast.variant}
                    onClose={() => onClose(toast.id)}
                    autohide
                >
                    {toast.variant === "danger" && (
                        <Toast.Header>
                            <strong className="me-auto">Error!</strong>
                        </Toast.Header>
                    )}

                    {toast.variant === "success" && (
                        <Toast.Header>
                            <strong className="me-auto">Sucesso!</strong>
                        </Toast.Header>
                    )}


                    {toast.variant === "info" && (
                        <Toast.Header>
                            <strong className="me-auto">Informação</strong>
                        </Toast.Header>
                    )}

                    {toast.variant === "warning" && (
                        <Toast.Header>
                            <strong className="me-auto">Alerta!</strong>
                        </Toast.Header>
                    )}


                    <Toast.Body className="text-light fw-bold">{toast.message}</Toast.Body>
                </Toast>
            ))}
        </ToastContainer>
    );
}
